import * as React from 'react';
import {authorize, Overlay} from "@athena-portal/components";
import {lazyInject} from "@athena-portal/core";
import {
    FalconPaymentRequest,
    ICustomerPortalService,
    resourcesHelper,
    Types,
    VerifyNewCardResponse
} from "@falcon/services";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import {Redirect, RouteComponentProps} from "react-router-dom";
import {getAmountWithDecimalDigits, getSessionStorage} from "../../../../CommonFunctions";

interface IPaymentProcessingPageParams {
    policyNumber: string;
    paymentReference: string;
}

interface IProps extends RouteComponentProps<IPaymentProcessingPageParams> {
}

interface IState {
    paymentSuccess: boolean;
    paymentCancelled: boolean;
    cardVerified: boolean;
    paymentAmountReceived: boolean;
    settings: any,
}

@authorize
export class CardPaymentProcessingPage extends React.Component<IProps, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: IProps) {
        super(props);

        this.state = {
            paymentSuccess: false,
            paymentCancelled: false,
            cardVerified: false,
            settings: getSessionStorage("paymentSettings"),
            paymentAmountReceived: false
        };

        this.newCardPaymentVerify = this.newCardPaymentVerify.bind(this);
        this.verificationNeeded = this.verificationNeeded.bind(this);
    }

    public componentDidMount() {
        this.pluginTemplates.setPageTitle("Payment processing");

        if (this.verificationNeeded()) {
            this.newCardPaymentVerify(this.props.match.params.paymentReference);
        }
    }

    public render() {
        const {
            paymentSuccess,
            paymentCancelled,
            cardVerified
        } = this.state;

        if (cardVerified) {
            if (!paymentSuccess && !paymentCancelled) {
                return <Redirect to={{
                    pathname: `/dashboard/account/newCardPayment/${this.props.match.params.policyNumber}`,
                    state: { verifyCardFailed: true }
                    }}
                />
            } else {

                const redirectUrl: string = this.state.settings.returnUrl

                if (paymentSuccess) {
                    window.sessionStorage.setItem("showPopup", "true");
                    this.customerPortalService.getSettledAmountByPaymentReference(this.props.match.params.paymentReference).subscribe((amount: number) => {
                        window.sessionStorage.setItem("paymentAmount", getAmountWithDecimalDigits(amount).toString());
                        this.setState({paymentAmountReceived:true});
                    });
                    if (this.state.paymentAmountReceived) {
                        return <Redirect to={redirectUrl} />
                    }
                } else {
                    return <Redirect to={redirectUrl} />
                }
            }
        }

        return (
            <React.Fragment>
                <Overlay show={true} />
                <FalconHeader/>
                <div className="panel panel-processing">
                    <span className="loading-animation"></span>
                    <h1 className="panel-heading">Processing...</h1>
                    <h2 className="text-center h5">Once your {resourcesHelper.THEME} insurance subscription is set up, you will see a payment confirmation screen and you will receive a confirmation email.</h2>
                    <p>Please wait...</p>
                    <p>Don't refresh or close your browser...</p>
                    <img className="car" src="/img/Flourishes-5.svg"/>
                </div>
                <FalconFooter/>
            </React.Fragment>
        )
    }

    private newCardPaymentVerify(paymentReference: string): void {
        const request: FalconPaymentRequest = new FalconPaymentRequest();
        request.invoiceType = this.state.settings.invoiceType;
        this.customerPortalService.newCardPaymentVerify(request, paymentReference).subscribe((response: VerifyNewCardResponse) => {
            this.setState({
                paymentSuccess: response && response.successful,
                paymentCancelled: response && response.cancelled,
                cardVerified: true
            });
        });
    }

    private verificationNeeded(): boolean {
        return this.props.match.params.paymentReference != null;
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/CardPaymentProcessingPage.tsx